import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useUserContext } from '../Components/StateContext/UserContext';
import { RouteComponentProps, withRouter, useParams } from 'react-router-dom';

interface TileSpec {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
  hidden?: boolean;
}

const TILES_PER_ROW = 3;

const renderTile = (tile: TileSpec, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card">
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? "ods-grid__column--4 ods-color-text-grayscale-10" : "ods-grid__column--4"}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const FrontpageView: React.FC<RouteComponentProps> = (props) => {
  const { depId, classId, week } = useParams<{ depId: string; classId: string; week: string }>();
  const { department, userRoles } = useUserContext();

  const isParentOnly = userRoles.length > 0 && userRoles.every(r => r === 'parent');
  const isAdminOrLocalAdmin = userRoles.includes('admin') || userRoles.includes('localadmin');

  useEffect(() => {}, [depId, classId, week, department]);

  const tiles: TileSpec[] = [
    { label: 'Fravær',                icon: 'ods-icon--success-square',                                              disabled: true },
    { label: 'Brukersøk',             icon: 'ods-icon--magnifying-glass-big',                                        disabled: true },
    { label: 'Min side',              icon: 'ods-icon--user',               href: '/myuserdetails',                  disabled: false },
    { label: 'Rapporter',             icon: 'ods-icon--message',            href: '/rapporter',                       disabled: !isAdminOrLocalAdmin },
    { label: 'Rom booking',           icon: 'ods-icon--calendar',                                                    disabled: true },
    { label: 'Opprett bruker',        icon: 'ods-icon--plus-sign',                                                   disabled: true },
    { label: 'Betalinger',            icon: 'ods-icon--coin-stacks',                                                 disabled: true },
    { label: 'Eksamensregistrering',  icon: 'ods-icon--document',           href: '/eksamensregistrering',           disabled: false },
  ];

  const visible = tiles.filter(t => !t.hidden);
  const sorted = [...visible].sort((a, b) => Number(a.disabled) - Number(b.disabled));

  const rows: TileSpec[][] = [];
  for (let i = 0; i < sorted.length; i += TILES_PER_ROW) {
    rows.push(sorted.slice(i, i + TILES_PER_ROW));
  }

  return (
    <>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="ods-grid ods-grid--gap-row-large ods-margin-top-25 ods-text--align-center">
          <div className="ods-grid__column--12">
            <div className="ods-grid ods-grid--gap ods-grid--center">
              {row.map((tile, colIndex) => renderTile(tile, rowIndex * TILES_PER_ROW + colIndex))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default withRouter(FrontpageView);
